<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xSf9Wj/images/mycover.png?1695124708870" alt="This image is the cover for the book Katherine Anne Porter and Mexico"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Katherine Anne Porter and Mexico
      </h1>
      <p class="bookDescription body article font2">
        <p>In 1920, an unknown journalist named Katherine Anne Porter first sojourned in Mexico. When she left her "familiar country" for the last time in 1931, she was the celebrated author of Flowering Judas and Other Stories and had accumulated a wealth of experiences and impressions that would inspire numerous short stories, essays, and reviews, as well as the opening section of her only novel, Ship of Fools. In this perceptive study of Porter's Mexican experiences, Thomas Walsh traces the important connections between those events and her literary works. Separating fact from the fictions that Porter constantly created about her life, he follows the active role that she played in Mexican political and intellectual life—even to the discovery of a plot to overthrow the Mexican government, which eventually figured in Flowering Judas. Most important, Walsh discerns how the great swings between depression and elation that characterized Porter's emotional life influenced her alternating visions of Mexico. In such works as "Xochimilco," Porter saw Mexico as an earthly Eden where hopes for a better society could be realized, but in other stories, including "The Fiesta of Guadalupe," she depicts Mexico as a place of hopeless oppression for the native peoples. Mexico, Porter once said, gave her back her Texas past. Given the unhappiness of that past, her feelings toward Mexico would always be ambivalent, but her Mexican experiences influenced all her subsequent works to some degree, even those pieces not specifically Mexican in setting. Walsh's study, then, is an essential key for anyone seeking greater understanding of the life or works of Katherine Anne Porter.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas F. Walsh
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d8b8a8ee